import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmptyBoxPlus = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 240,
	height: 138,
	viewBox: "0 0 240 138",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			opacity: .5,
			d: "M151.209 9.34953V128.43C151.209 129.613 151.441 130.783 151.895 131.876C152.347 132.968 153.011 133.96 153.848 134.795C154.682 135.631 155.675 136.293 156.768 136.744C157.859 137.195 159.032 137.426 160.212 137.423H175.779C172.755 137.423 169.857 136.222 167.719 134.083C165.581 131.945 164.382 129.044 164.382 126.019C164.382 122.994 165.581 120.093 167.719 117.955C169.857 115.816 172.755 114.614 175.779 114.614H228.602C231.626 114.614 234.524 113.413 236.662 111.274C238.8 109.135 240 106.234 240 103.21C240 100.185 238.8 97.2842 236.662 95.1453C234.524 93.0065 231.626 91.805 228.602 91.805H199.765C196.741 91.805 193.843 90.6035 191.705 88.4646C189.567 86.3258 188.367 83.4251 188.367 80.4005C188.367 77.3756 189.567 74.475 191.705 72.3361C193.843 70.1972 196.741 68.9958 199.765 68.9958H228.602C231.626 68.9958 234.524 67.7942 236.662 65.6554C238.8 63.5165 240 60.6159 240 57.5912C240 54.5664 238.8 51.6657 236.662 49.5268C234.524 47.388 231.626 46.1865 228.602 46.1865H191.428C188.404 46.1865 185.506 44.985 183.368 42.8461C181.23 40.7073 180.031 37.8066 180.031 34.7817C180.031 31.7571 181.23 28.8565 183.368 26.7176C185.506 24.5787 188.404 23.3772 191.428 23.3772H212.97C215.994 23.3772 218.892 22.1757 221.03 20.0369C223.168 17.898 224.368 14.9974 224.368 11.9725C224.368 8.94791 223.168 6.04708 221.03 3.9083C218.892 1.76952 215.994 0.567967 212.97 0.567967H160.212C157.862 0.563054 155.603 1.47955 153.919 3.12104C152.238 4.76253 151.263 6.9984 151.209 9.34953Z",
			fill: "url(#paint0_linear_801_9575)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M156.611 47.5977V61.4899C156.611 62.9534 153.676 64.1381 150.076 64.1381H26.6506C23.04 64.1381 20.1152 62.9534 20.1152 61.4899V53.4489C28.4359 55.6628 37.9094 57.1558 47.6257 58.0832C59.3675 59.2036 71.4696 59.5306 83.521 59.5788C97.9314 59.6378 112.582 59.2866 126.146 57.3219C138.577 55.5261 150.102 52.2159 156.611 47.5977Z",
			fill: "#DDE9EC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M149.723 65.2611H26.7381C24.6634 65.259 22.6742 64.4305 21.2069 62.9571C19.7396 61.484 18.914 59.4863 18.9111 57.4024V26.766C18.914 24.6821 19.7396 22.6845 21.2069 21.2112C22.6742 19.7379 24.6634 18.9094 26.7381 18.9072H149.723C151.798 18.9094 153.788 19.7383 155.255 21.2122C156.722 22.686 157.548 24.6844 157.55 26.7687V57.4051C157.546 59.4885 156.72 61.4853 155.253 62.9582C153.786 64.4308 151.797 65.259 149.723 65.2611ZM26.7381 21.0515C25.2294 21.0529 23.7828 21.6554 22.7157 22.7267C21.6486 23.7979 21.0481 25.2506 21.046 26.766V57.4024C21.0474 58.9181 21.6476 60.3717 22.7148 61.4435C23.7819 62.5154 25.2289 63.1182 26.7381 63.1196H149.723C151.232 63.1182 152.679 62.5154 153.746 61.4435C154.813 60.3717 155.414 58.9181 155.415 57.4024V26.766C155.414 25.2502 154.813 23.7968 153.746 22.7249C152.679 21.6531 151.232 21.0502 149.723 21.0488L26.7381 21.0515Z",
			fill: "#9E96AF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M191.877 100.639L106.104 127.03L49.5509 100.639L49.0122 72.3622L37.2976 66.7069L49.5509 48.7984L30.6997 32.775L122.128 4.49832L135.324 20.5217L152.29 4.49832L208.843 32.775L191.877 48.7984L208.843 66.7069L206.015 67.6495L191.877 72.7329V100.639Z",
			fill: "#ECEAF0"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M106.104 77.075V127.03M49.5509 48.7984L37.2976 66.7069L49.0122 72.3622L91.9659 93.0984L106.104 77.075M106.104 77.075L191.877 48.7984M106.104 77.075L122.128 97.8112L206.015 67.6495M106.104 77.075L49.5509 48.7984M49.0122 72.3622L49.5509 100.639L106.104 127.03L191.877 100.639V72.3622L206.015 67.6495M191.877 48.7984L208.843 66.7069L206.015 67.6495M191.877 48.7984L208.843 32.775L152.29 4.49832L135.324 20.5217M191.877 48.7984L135.324 20.5217M135.324 20.5217L122.128 4.49832L30.6997 32.775L49.5509 48.7984M135.324 20.5217V66.7069M135.324 20.5217L49.5509 48.7984",
			stroke: "#35363A",
			strokeWidth: 1.88511
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.8935 3.64814C17.7995 1.63333 20.9781 1.54518 22.9929 3.45126L35.6482 15.4236C37.663 17.3297 37.7512 20.5082 35.8451 22.523L23.403 35.6749C21.4969 37.6897 18.3184 37.7778 16.3036 35.8717L3.64821 23.8994C1.63339 21.9933 1.54524 18.8148 3.45133 16.8L15.8935 3.64814Z",
			fill: "#DAE9ED"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.4998 19.5298H27.6611",
			stroke: "#35363A",
			strokeWidth: 2.46269,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.5806 11V28.0592",
			stroke: "#35363A",
			strokeWidth: 2.46269,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_801_9575",
			x1: 155.676,
			y1: 64.7515,
			x2: 249.824,
			y2: 63.1141,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#CDF5EE" }), /* @__PURE__ */ _jsx("stop", {
				offset: .38,
				stopColor: "#CDEAFB"
			})]
		}) })
	]
});
export default SvgEmptyBoxPlus;
